<template>
  <div class="dashboard" style="font-size: 0.8rem; margin-top:100px!important">
    <div class="w-100">
      <b-alert
        style="display: flex; justify-content: space-between"
        v-if="wppStatus === 'Conectado'"
        variant="success"
        show
      >
        <span>WhatsApp conectado!</span>
        <span style="font-size: 0.8rem; color: #666">
          {{ me.name }} ({{ me.phone }})
        </span>
      </b-alert>

      <b-alert v-if="wppStatus === 'Desconectado'" variant="warning" show>
        Aguardando conexão com o WhatsApp!
      </b-alert>

      <b-alert
        v-if="wppStatus === 'Aguardando leitura do QRCODE'"
        variant="warning"
        show
      >
        Aguardando leitura do QRCODE
      </b-alert>

      <b-alert v-if="wppStatus === 'STARTING'" variant="danger" show>
        Iniciando WhatsApp...
      </b-alert>
    </div>

    <div class="mb-3">
      <button
        class="btn btn-sm btn-primary"
        @click="getQrCodePrimary"
        v-if="['Desconectado'].includes(wppStatus)"
      >
        QR Code
      </button>
      <button
        class="btn btn-sm btn-dark"
        style="font-size: 0.8rem; margin-left: 10px"
        @click="disconnect"
      >
        Reiniciar
      </button>
    </div>
    <div
      class="d-flex justify-content-between mb-2 w-100"
      style="border-bottom: 3px solid #666; color: #666"
    >
      <h3 style="font-size: 1rem">{{ title }}</h3>
    </div>
    <div>
      <ListMarketing
        :body="body"
        @changeBody="(data) => (body = data)"
        :nextPage="nextPage"
        @clearBody="clearBody()"
        v-if="pageName === 'listCampanha'"
      />

      <NewMarketing
        :body="body"
        :nextPage="nextPage"
        v-if="pageName === 'newCampanha'"
      />

      <SelectCustomer
        :body="body"
        :nextPage="nextPage"
        v-if="pageName === 'selectClientes'"
      />

      <PreviewMarketing
        :body="body"
        :nextPage="nextPage"
        v-if="pageName === 'previewMarketing'"
      />

      <div class="w-100">
        <img v-if="qrCode" :src="`data:image/png;base64,${qrCode}`" />
      </div>
    </div>
  </div>
</template>

<script>
import NewMarketing from "./components/newMarketing.vue";
import ListMarketing from "./components/listMarketing.vue";
import SelectCustomer from "./components/selectCustomer.vue";
import PreviewMarketing from "./components/previewMarketing.vue";
import { ServiceWhatsaApp } from "../../services/ServiceWhatsaApp";

export default {
  components: {
    NewMarketing,
    ListMarketing,
    SelectCustomer,
    PreviewMarketing,
  },
  data() {
    return {
      title: "Marketing",
      pageName: "listCampanha",
      contacts: [],
      umvalor: 1,
      wppStatus: null,
      me: {
        phone: "",
        name: "",
      },
      qrCode: "",
      body: {
        id: null,
        name: "",
        message: "",
        data: "",
        hour: "",
        contacts: [],
      },
    };
  },
  methods: {
    async helthCheck() {
      try {
        const status = await ServiceWhatsaApp.healthCheck("marketing");
        this.wppStatus = status;

        if (status === "Conectado") {
          this.getMeSession();
        } else if (status === "Aguardando leitura do QRCODE") {
          this.getQrCodePrimary();
        } else if (status === "STARTING") {
          this.wppStatus = "Iniciando WhatsApp...";
        } else {
          this.wppStatus = "Desconectado";
        }
      } catch (error) {
        this.wppStatus = "Aguardando conexão com o WhatsApp!";
      }
    },
    async getMeSession() {
      try {
        const data = await ServiceWhatsaApp.me("marketing");
        this.me = {
          phone: data.id.replace("@c.us", "").substring(2),
          name: data.pushName,
        };
      } catch (error) {
        this.wppStatus = "Aguardando conexão com o WhatsApp!";
      }
    },
    async getQrCodePrimary() {
      this.$bvToast.toast("Gerando QR Code", {
        title: "Aguarde",
        variant: "info",
        solid: true,
        toaster: "b-toaster-bottom-right",
      });
      const qrcode = await ServiceWhatsaApp.getQrCodePrimary("marketing");

      this.qrCode = qrcode;

      this.$bvToast.toast("QR Code gerado com sucesso", {
        title: "Sucesso",
        variant: "success",
        solid: true,
        toaster: "b-toaster-bottom-right",
      });
    },
     async disconnect() {
      this.$toast.open({
        message: "Desconectando...",
        type: "info",
      });

      await ServiceWhatsaApp.disconnect("marketing");

      this.$toast.open({
        message: "Desconectado com sucesso",
        type: "success",
      });
    },
    nextPage(page) {
      this.pageName = page;
    },
    clearBody() {
      this.body = {
        id: null,
        name: "",
        message: "",
        data: "",
        hour: "",
        contacts: [],
      };
    },
  },
  created() {
    this.helthCheck();
  },
  watch: {
    pageName() {
      const titles = {
        listCampanha: "Campanhas",
        newCampanha: "Nova Campanha",
        selectClientes: "Selecionar Clientes",
      };

      this.title = titles[this.pageName];
    },
  },
};
</script>

<style scoped>
p {
  margin: 0px;
  padding: 0px;
  font-size: 14px;
}

.dashboard {
  width: 80%;
  margin-top: 35px;
}

@media screen and (min-width: 768px) and (max-width: 1200px) {
  .dashboard {
    width: 90%;
    margin-left: 30px;
  }
}

@media screen and (max-width: 700px) {
  .dashboard {
    width: 80%;
  }
}
</style>